import Vue from 'vue'
import Vuex from 'vuex'
import AppStore from './AppStore'
import UserStore from './UserStore'
import DocumentStore from './DocumentStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    AppStore,
    UserStore,
    DocumentStore
  }
})
